import { Image } from '@sitecore-jss/sitecore-jss-react';
import styles from './OffersHero.scss';

export default function OffersHero(props) {
  const { fields } = props;
  const { heroTitle, heroImage } = fields;

  const hasValidImage =
    heroImage &&
    (heroImage.fields?.desktopImage?.value?.src ||
      heroImage.fields?.tabletImage?.value?.src ||
      heroImage.fields?.mobileImage?.value?.src);

  const title = heroTitle?.value || '';

  return (
    <div className={'container offers-hero'}>
      <div className={'wrapper'} data-aos="fade-up">
        {hasValidImage ? (
          <Image field={heroImage.fields.desktopImage} className={'backgroundImage'} />
        ) : (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: '#f0f0f0',
              borderRadius: '20px',
              zIndex: -1,
            }}
          />
        )}
        <div className={'title'} dangerouslySetInnerHTML={{ __html: title }}></div>
      </div>
    </div>
  );
}
